import { render, staticRenderFns } from "./ProveedorGrid.vue?vue&type=template&id=dd285576&"
import script from "./ProveedorGrid.vue?vue&type=script&lang=ts&"
export * from "./ProveedorGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('dd285576', component.options)
    } else {
      api.reload('dd285576', component.options)
    }
    module.hot.accept("./ProveedorGrid.vue?vue&type=template&id=dd285576&", function () {
      api.rerender('dd285576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ClienteProveedor/ProveedorGrid.vue"
export default component.exports